import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

const BACK_LINK_CLASSES =
  'inline-flex items-center gap-1 self-start text-button-sm text-muted-foreground hover:text-foreground'

/**
 * Top-left back affordance used on portal sub-pages (edit / verify
 * flows). Text-link styling, muted colour, small chevron - visually
 * subordinate to the page's headline so it doesn't compete for
 * attention.
 *
 * Kept as a plain `<Link>` rather than a button so browser
 * behaviour (right-click open, keyboard, etc.) works for free.
 */
export function PageBackLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to} className={BACK_LINK_CLASSES}>
      <ChevronLeft className="size-4" aria-hidden="true" />
      {children}
    </Link>
  )
}

/**
 * Same visual language as `PageBackLink`, but the destination is
 * caller-supplied state rather than a route. Used e.g. inside a
 * multi-panel page where "back" slides to a previous panel and
 * runs cleanup logic.
 */
export function PageBackButton({
  onClick,
  children,
}: {
  onClick: () => void
  children: ReactNode
}) {
  return (
    <button type="button" onClick={onClick} className={BACK_LINK_CLASSES}>
      <ChevronLeft className="size-4" aria-hidden="true" />
      {children}
    </button>
  )
}
